{
	"loading": "Loading page…",
	"loadError": "This page could not load",
	"retry": "Try again",
	"breadcrumbs": "Where this page is",
	"edited": "Edited {{time}}",
	"missing": {
		"title": "Page not found",
		"body": "It may have been deleted for good, or the link is wrong.",
		"home": "Go home"
	},
	"favorite": {
		"add": "Add to favorites",
		"remove": "Remove from favorites"
	},
	"save": {
		"saved": "Saved",
		"pending": "Unsaved changes",
		"saving": "Saving…",
		"offline": "Offline — changes kept, retrying",
		"conflict": "Changed elsewhere",
		"error": "Not saved"
	},
	"conflict": {
		"body": "Someone else saved this page while you were editing it. Reload to see their version — changes you made on this screen since your last save will be lost.",
		"reload": "Reload page"
	},
	"menu": {
		"label": "Page options",
		"copyLink": "Copy link",
		"linkCopied": "Link copied",
		"moveTo": "Move to…",
		"moveToTitle": "Move into which page?",
		"moveTop": "Move to top level",
		"moved": "Page moved",
		"trash": "Move to trash",
		"trashed": "Moved to the trash",
		"trashTitle": "Move this page to the trash?",
		"trashBody": "Its sub-pages go with it. You can restore it from the Trash.",
		"open": "Open",
		"openNewTab": "Open in new tab",
		"addPageInside": "Add a page inside",
		"addBoardInside": "Add a board inside",
		"rename": "Rename",
		"trashTitleNamed": "Move “{{title}}” to the trash?",
		"fullWidth": "Full width",
		"duplicate": "Duplicate",
		"duplicated": "Page duplicated",
		"history": "Page history",
		"exportPdf": "Export as PDF"
	},
	"cover": {
		"add": "Add cover",
		"change": "Change cover",
		"reposition": "Reposition",
		"remove": "Remove",
		"savePosition": "Save position",
		"cancel": "Cancel",
		"dragHint": "Drag the image to reposition",
		"tabs": {
			"gallery": "Gallery",
			"upload": "Upload"
		},
		"onThisPage": "Images on this page",
		"upload": "Upload an image",
		"uploading": "Uploading…",
		"uploadHint": "PNG, JPEG or WebP up to {{max}}. Wide images work best (1500 px or more).",
		"imageType": "Use a PNG, JPEG or WebP image.",
		"tooLarge": "That image is too large. The limit is {{max}}.",
		"presets": {
			"RIBBON": "SEA Games ribbon",
			"BOARD": "Games blue",
			"SUNRISE": "Sunrise",
			"OCEAN": "Ocean",
			"FOREST": "Forest",
			"DUSK": "Dusk",
			"PEACH": "Peach",
			"MINT": "Mint",
			"GRAY": "Gray",
			"RED": "Red",
			"ORANGE": "Orange",
			"YELLOW": "Yellow",
			"GREEN": "Green",
			"BLUE": "Blue",
			"PURPLE": "Purple",
			"PINK": "Pink"
		}
	},
	"history": {
		"title": "Page history",
		"versions": "Versions",
		"preview": "Selected version",
		"versionOf": "{{time}} · {{name}}",
		"current": "Current version · {{name}}",
		"loading": "Loading history…",
		"loadError": "History could not load. Try again.",
		"empty": "No earlier versions yet. A version is saved every few minutes while someone types, and when they leave the page.",
		"older": "Show older",
		"back": "Back to versions",
		"close": "Close",
		"restore": "Restore this version",
		"restoreHint": "Restoring keeps the current text as a version too, so you can undo it here.",
		"restored": "Restored the version from {{time}}"
	},
	"trash": {
		"title": "Trash",
		"subtitle": "Pages moved to the trash, with their sub-pages. Restore one, or delete it for good.",
		"banner": "This page is in the trash.",
		"restore": "Restore",
		"restored": "Page restored",
		"restoredNamed": "Restored “{{title}}”",
		"delete": "Delete for good",
		"deleteTitle": "Delete for good?",
		"deleteBody": "This page, its sub-pages, boards, files and history are deleted. This cannot be undone.",
		"deleteBodyNamed_zero": "“{{title}}”, its files and its history are deleted. This cannot be undone.",
		"deleteBodyNamed_one": "“{{title}}” and its {{count}} sub-page, with their files and history, are deleted. This cannot be undone.",
		"deleteBodyNamed_other": "“{{title}}” and its {{count}} sub-pages, with their files and history, are deleted. This cannot be undone.",
		"by": "Moved by {{name}}, {{time}}",
		"withSub_one": "{{count}} sub-page",
		"withSub_other": "{{count}} sub-pages",
		"emptyTitle": "The trash is empty",
		"emptyBody": "Pages you move to the trash wait here until you restore or delete them.",
		"more": "Show more"
	},
	"icon": {
		"add": "Add icon",
		"change": "Change icon",
		"pick": "Pick an icon",
		"remove": "Remove",
		"random": "Random",
		"tabs": {
			"emoji": "Emoji",
			"icons": "Icons",
			"custom": "Custom"
		},
		"searchEmoji": "Search emoji",
		"searchIcons": "Search icons",
		"none": "Nothing matches.",
		"loadError": "Icons could not load. Try again.",
		"recent": "Recent",
		"groups": {
			"smileys": "Smileys & emotion",
			"people": "People & body",
			"nature": "Animals & nature",
			"food": "Food & drink",
			"travel": "Travel & places",
			"activities": "Activities",
			"objects": "Objects",
			"symbols": "Symbols",
			"flags": "Flags"
		},
		"lineGroups": {
			"documents": "Documents",
			"work": "Work & planning",
			"people": "People",
			"games": "Sport & health",
			"places": "Places & travel",
			"tech": "Tech & tools",
			"money": "Money",
			"signs": "Signs"
		},
		"color": "Icon colour",
		"colors": {
			"GRAY": "Gray",
			"BROWN": "Brown",
			"ORANGE": "Orange",
			"YELLOW": "Yellow",
			"GREEN": "Green",
			"BLUE": "Blue",
			"PURPLE": "Purple",
			"PINK": "Pink",
			"RED": "Red"
		},
		"upload": "Upload an image",
		"uploading": "Uploading…",
		"customHint": "PNG, JPEG or WebP up to {{max}}. Square images look best. Everyone in the workspace can use it.",
		"customType": "Use a PNG, JPEG or WebP image.",
		"customTooLarge": "That image is too large. The limit is {{max}}.",
		"customEmpty": "No custom icons yet. Upload a logo or a mascot to use it on any page.",
		"customLibrary_one": "Workspace icons · {{count}}",
		"customLibrary_other": "Workspace icons · {{count}}",
		"customDelete": "Delete {{name}}",
		"customDeleteTitle": "Delete the icon “{{name}}”?",
		"customDeleteBody": "Pages that use it go back to the default icon. This cannot be undone.",
		"customDeleteConfirm": "Delete icon"
	},
	"title": {
		"label": "Page title",
		"placeholder": "Untitled"
	},
	"home": {
		"greeting": "Hello, {{name}}",
		"subtitle": "Write a guide, keep notes with screenshots, or track work on a board.",
		"newPage": "New page",
		"newBoard": "New board",
		"recent": "Recently edited",
		"loading": "Loading recent pages…",
		"loadError": "Recent pages could not load. Try again.",
		"emptyTitle": "Nothing here yet",
		"emptyBody": "Create the first page — a user guide, meeting notes, or a checklist.",
		"editedBy": "{{name}} · {{time}}"
	},
	"byline": {
		"created": "Created by {{name}}, {{time}}",
		"edited": "Last edited by {{name}}, {{time}}"
	},
	"presence": {
		"viewing_one": "{{names}} is viewing this",
		"viewing_other": "{{names}} are viewing this",
		"profile": "About {{name}}",
		"others": "Everyone viewing",
		"more": "Show {{count}} more viewers",
		"activeNow": "Viewing now",
		"email": "Email",
		"noEmail": "No email on file",
		"copyEmail": "Copy email",
		"copied": "Email copied",
		"lastSignIn": "Last signed in {{time}}",
		"back": "All viewers"
	},
	"activity": {
		"toggle": "Activity",
		"title": "Activity",
		"close": "Close activity",
		"loading": "Loading activity…",
		"loadError": "Activity could not load. Try again.",
		"empty": "Nothing has happened here yet.",
		"more": "Show older",
		"system": "System",
		"editedText": "edited the text",
		"fallback": {
			"INSERT": "added {{what}}",
			"UPDATE": "changed {{what}}",
			"DELETE": "removed {{what}}"
		},
		"workspaceTitle": "Activity",
		"workspaceSubtitle": "Everything that happened in the workspace, newest first: who created, edited, moved, trashed or deleted what."
	},
	"members": {
		"title": "Members",
		"subtitle": "Everyone with the Super Admin role can use WSL Notion. To add or remove someone, give or take away the Super Admin role in GMS → Users.",
		"search": "Search by name or username",
		"loadError": "Members could not load. Try again.",
		"empty": "No members match.",
		"name": "Name",
		"username": "Username",
		"email": "Email",
		"lastSignIn": "Last sign-in",
		"never": "Never",
		"more": "Show more"
	},
	"deployments": {
		"title": "Deployments",
		"subtitle": "Whether your push is live, still building or failed, read from Dokploy. Nothing here can start or stop a deployment.",
		"updated": "Updated {{time}}",
		"unreachable": "Couldn't reach Dokploy, retrying. Showing what it said last.",
		"loadError": "Deployments could not load. Try again.",
		"notConnected": {
			"title": "Deployments aren't connected yet",
			"body": "The workspace has no Dokploy connection set up. Once it does, every app and its latest builds show here."
		},
		"noApps": "Dokploy has no apps to show.",
		"find": {
			"label": "Find your commit",
			"placeholder": "Paste a commit SHA (7+ characters) or words from its message",
			"clear": "Clear",
			"hint": "Searches each app's last {{count}} deployments.",
			"none": "Not seen in any app's recent deployments. If you just pushed, Dokploy may not have picked it up yet.",
			"matched_one": "Found in {{count}} app",
			"matched_other": "Found in {{count}} apps",
			"others_one": "Not deployed yet in {{count}} other app",
			"others_other": "Not deployed yet in {{count}} other apps"
		},
		"state": {
			"building": "Building…",
			"queued": "Queued",
			"failed": "Failed",
			"live": "Live",
			"none": "No deployments",
			"done": "Succeeded"
		},
		"verdict": {
			"live": "Live",
			"building": "Building now",
			"queued": "Queued",
			"failed": "Failed",
			"replaced": "Deployed, newer build live",
			"notDeployed": "Not deployed yet"
		},
		"verdictLine": {
			"live": "Live since {{time}}.",
			"building": "Building now, started {{time}}.",
			"queued": "Waiting in Dokploy's queue.",
			"failed": "The build failed at {{time}}.",
			"replaced": "Went live at {{time}}; a newer build has gone live since.",
			"failedNewerLive": "The build failed at {{time}}; a newer build has gone live since.",
			"notDeployed": "Not in this app's recent deployments.",
			"notDeployedQueued": "Not in this app's recent deployments; a deployment is waiting in the queue."
		},
		"liveSince": "Live: {{sha}} {{title}} since {{time}}",
		"noLive": "Nothing live on record",
		"noDeployments": "No deployments yet",
		"running": "running {{duration}}",
		"took": "took {{duration}}",
		"recentStrip": "Last deployments, oldest to newest",
		"open": "Open the history of {{name}}",
		"history": {
			"title": "{{name}} deployments",
			"label": "Deployment history",
			"close": "Close",
			"loading": "Loading deployments…",
			"loadError": "The history could not load. Try again.",
			"empty": "No deployments yet.",
			"copyLink": "Copy link",
			"linkCopied": "Link copied",
			"back": "Back to the list",
			"pick": "Pick a deployment to read its build log.",
			"count_one": "Last {{count}} deployment",
			"count_other": "Last {{count}} deployments"
		},
		"log": {
			"title": "Build log",
			"loading": "Loading the log…",
			"loadError": "The log could not load. Try again.",
			"empty": "The log is empty.",
			"truncated_one": "Showing the last {{count}} line.",
			"truncated_other": "Showing the last {{count}} lines.",
			"jumpError": "Jump to first error",
			"copy": "Copy log",
			"copied": "Log copied",
			"following": "Following the log",
			"copySha": "Copy commit SHA",
			"shaCopied": "Commit SHA copied",
			"noSha": "No commit SHA",
			"errorMessage": "Dokploy says: {{message}}"
		}
	}
}
